export enum ResidentNameFormatModel {
	LastNameFirstNameComma = 1,
	LastNameFirstNameSpace = 2,
	FirstNameLastNameSpace = 3,
	FirstNameLastNameComma = 4,
	FirstName = 5,
	LastNameFirstNameCommaResidentId = 6
}
